module.exports = __webpack_public_path__ + "static/media/picnicker-normal-yeti.ca1b99bb.png";